// @ts-nocheck

"use client";

import Script from "next/script";

const handleJqueryReady = () => {
    $(".ji-close").click(function(){
        $(".disclamer").hide();
        $('body').addClass('mt-80p');
    });

// header
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100){
            $('header').addClass("sticky");
            $('header-link').addClass('text-white');
        }else{
            $('header').removeClass("sticky");
            $('header-link').removeClass('text-white');
        }
    });

    function menuOnClick() {
        document.getElementById("menu-bar").classList.toggle("change");
        document.getElementById("nav").classList.toggle("change");
        document.getElementById("menu-bg").classList.toggle("change-bg");
    }

    $(".three-step-head-pd").click(function(){
        $(".three-step-head-pd").removeClass('ji-active');
        $(this).addClass('ji-active')
    });


    $(".ji-choose-ipif").click(function(){
        $(".ji-choose-ipif").removeClass('ji-pif-active');
        $(this).addClass('ji-pif-active')
    });

    $(function() {
        let filter = $("[data-filter]");
        filter.on("click", function(event) {
            event.preventDefault();
            let cat = $(this).data('filter');
            $("[data-cat]").each(function() {
                let workCat = $(this).data('cat');

                if(workCat != cat) {
                    $(this).addClass('hide');
                }else {
                    $(this).removeClass('hide');
                }
            });
        });
    });

// header menu

        $('#nav-icon3').click(function(){
            $(this).toggleClass('open');

            $('#myLinks').toggleClass('hide-mobileMenu')
            $('#myLinks').toggleClass('mobile-menu-animation')

        });



    $('.toggle').click(function(e) {
        e.preventDefault();
        /*   */
        if ($(this).hasClass('toggle-border-radius')) {
            document.querySelectorAll('.toggle').forEach(item => {
                item.classList.remove('toggle-border-radius');
            })
            $(this).removeClass('toggle-border-radius');
        } else {
            document.querySelectorAll('.toggle').forEach(item => {
                item.classList.remove('toggle-border-radius');
            })
            $(this).addClass('toggle-border-radius');
        }
        var $this = $(this);

        if ($this.next().hasClass('show')) {
            $this.next().removeClass('show');
            $this.next().slideUp(350);

        } else {
            $this.parent().parent().find('li .inner').removeClass('show');
            $this.parent().parent().find('li .inner').slideUp(350);
            $this.next().toggleClass('show');
            $this.next().slideToggle(350);
        }
    });


    $('.blog-categories-title').on('click', function() {
        $(this).parent().toggleClass('active')
    })

    $('.blog-categories .close').on('click', function() {
        $('.blog-categories').removeClass('active')
    })
// read more

    $('.read-more').click(function() {
        $(this).prev().slideToggle();
        if (($(this).text()) == "Читать больше") {
            $(this).text("Читать меньше");
        } else {
            $(this).text("Читать больше");
        }
    });
    $('.read-more-kz').click(function() {
        $(this).prev().slideToggle();
        if (($(this).text()) == "Толығырақ оқу") {
            $(this).text("Аз оқу");
        } else {
            $(this).text("Толығырақ оқу");
        }
    });

    /**На главной почему «Alatau City Invest» бордер слева при клике на кнопки**/
        $('.teh').hasClass('uk-active')
        $('.border-l').hide();
        $('.border-r').show();

        $('.teh').on('click', function () {
            $('.border-l').hide();
            $('.border-r').show();
        });
        $('.flex').on('click', function () {
            $('.border-l').hide();
            $('.border-r').hide();
        });

        $('.act').on('click', function () {
            $('.border-l').show();
            $('.border-r').hide();
        });



    /**Каталог инвестиционных инструментов переключение инвестирование и готовые регения**/
    // Hide all content blocks initially
    $('.tab-2').hide();

    $('#tab-1').click(function () {
        $('.tab-1').show();
        $('.tab-2').hide();
    });
    // Handle click events on tabs
    $('#tab-1').click(function(e) {
        e.preventDefault();
        $('.tab-2').hide();
        $('.tab-1').show();
        // Add or remove active class as needed
        $(this).addClass('active-tab');
        $('#tab-2').removeClass('active-tab');
    });
    $('#tab-2').click(function(e) {
        e.preventDefault();
        $('.tab-1').hide();
        $('.tab-2').show();
        // Add or remove active class as needed
        $(this).addClass('active-tab');
        $('#tab-1').removeClass('active-tab');
    });
}

const onSplideReady = () => {
    /**О нас пишут свайпер**/
    var splide = new Splide( '.splide',{
        type  : 'loop',
        drag   : 'free',
        pagination: true,
        arrows : false,
        autoWidth: true,
        perPage: 5,
        autoplay: true,
        focus: window.innerWidth === 768 ? 'center' : 'left', // Изменено значение focus в зависимости от ширины экрана

    } );splide.mount();
}


const onSwiperReady = () => {

// Слайдер на главной
    const swiperMain = new Swiper('.main-page-slider', {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        on: {
            // slideChange: function (sw) {
            //     let slide = $('.main-page-slider .swiper-slide:not(.swiper-slide-duplicate)')
            //     let total = slide.length < 9 ? ('0' + slide.length) : slide.length
            //     $('.main-page-slider__total').text(total)
            //     let curret = sw.realIndex < 9 ?  ('0' + (sw.realIndex + 1)) : (sw.realIndex + 1)
            //     $('.main-page-slider__current').text(curret)
            // },
        },
        loopedSLides: 1,
        loop: true,
        simulateTouch: true,
        spaceBetween: 100,
        direction: 'horizontal',
        centeredSlides: true,
        grabCursor: true,
        speed: 1000,
        pagination: {
            el: '.swiper-paginat',
            clickable: true,
        },
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // autoplay: {
        //   delay: 1500,
        // }
    })

    var swiper = new Swiper(".main-page-second-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        simulateTouch: true,
        grabCursor: true,
        loop: true,
        // autoplay: true
    });

// slider on smi block
    var swiper = new Swiper(".mySwiper", {
        slidesPerView: 3,
        grabCursor: true,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 102500,
            disableOnInteraction: false,
        },
        breakpoints: {
            320: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 50,
            },
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

    });



    let ticker = document.querySelectorAll('.ticker-animation')
    if(ticker) {
        ticker.forEach( el => {
            let list = Array.from(el.querySelectorAll('.ticker-animation__list'))

            list.forEach(elem => {
                let clone = elem.cloneNode(true)
                el.appendChild(clone)
            })
        })
    }
}


export const MainPageScripts = () => {
    return <>
        <Script onReady={onSwiperReady} src="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js"></Script>
        <Script onReady={onSplideReady} src="https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js"></Script>
        <Script onReady={handleJqueryReady} src="https://code.jquery.com/jquery-3.6.4.min.js"/>
    </>
}